/* istanbul ignore file */
import { css } from 'styled-components';

export const scrollableContent = css`
  flex-shrink: 1;
  flex-grow: 1;
  overflow-y: scroll;
`;
